<script setup lang="ts">
import { localizeUrl } from '@shared/fondof-fn/url/localize'
import config from '@storefront-satch/config'

import { AffenzahnIcon, AlviIcon, ErgobagIcon } from '@fond-of/fondof-icons'
import { StorefinderIcon } from '@fond-of/satch-icons'

const props = defineProps<{
  storefinder: {
    url: string
    label: string
  }
}>()
</script>

<template>
  <div
    v-if="props.storefinder"
    class="block border-t border-t-[#b2b8c0] pt-4 text-left lg:hidden"
  >
    <a
      class="flex w-full items-center p-5 text-[15px] font-bold leading-[21px] text-black"
      :href="localizeUrl(`/${props.storefinder?.url}`)"
      data-gtm-attr="button_header_item"
      data-gtm-label="Storefinder mobile"
    >
      <span class="pr-1.5">
        <StorefinderIcon
          width="22px"
          height="22px"
        />
      </span>
      <span>{{ props.storefinder?.label }}</span>
    </a>
  </div>
  <div
    class="bg-gray-nav flex w-full items-center justify-center py-[5vw] sm:py-[4vw] md:p-[3vw] lg:hidden"
  >
    <div class="w-full">
      <ul class="flex w-full items-center justify-around">
        <li>
          <a
            :href="`${config.crossbrand.alvi.url}${config.crossbrand.utmParamsHeader || ''}`"
            class="text-gray-icon mr-0 flex flex-wrap items-center justify-center"
            target="_blank"
            data-gtm-attr="button_crossbrand_header"
            data-gtm-label="alvi"
          >
            <span class="hover:opacity-90">
              <AlviIcon
                height="22px"
                width="100px"
              />
            </span>
          </a>
        </li>
        <li>
          <a
            :href="`${config.crossbrand.affenzahn.url}${config.crossbrand.utmParamsHeader || ''}`"
            class="text-gray-icon mr-0 flex flex-wrap items-center justify-center"
            target="_blank"
            data-gtm-attr="button_crossbrand_header"
            data-gtm-label="affenzahn"
          >
            <span class="hover:opacity-90">
              <AffenzahnIcon
                height="29px"
                width="100px"
              />
            </span>
          </a>
        </li>
        <li>
          <a
            :href="`${config.crossbrand.ergobag.url}${config.crossbrand.utmParamsHeader || ''}`"
            class="text-gray-icon [&_path]:fill-gray-icon mr-0 flex flex-wrap items-center justify-center"
            target="_blank"
            data-gtm-attr="button_crossbrand_header"
            data-gtm-label="ergobag"
          >
            <span class="hover:opacity-90">
              <ErgobagIcon
                height="24px"
                width="100px"
              />
            </span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>
